import React from "react";
import { Row, Col, FormGroup, InputGroup, Input, Button } from "reactstrap";
import { SmallFormFeedback, Spacer, PinkButtonContainer, EditIcon } from "../../../../utils/budget-tool-specific";
import { RebelColors } from "../../../../styles/rebel-experiences";
import styled from "styled-components";

const RebelMiscellaneousInputs = (props) => {

    return (
        <React.Fragment>
            <Row key={props.i} style={{alignItems: "flex-end"}}>
                <Col lg="5">
                    <FormGroup style={{marginBottom: 0}}>
                        <RebelLabel>Cost Title</RebelLabel>
                        <InputGroup>
                            <RebelInputStandalone
                                placeholder=""
                                type="text"
                                value={props.miscCost[1].title}
                                onChange={e => props.handleMiscellaneousChange(e.target.value, props.miscCost[1].id, "title")}
                            />
                            <RebelFormFeedback>Required</RebelFormFeedback>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup style={{marginBottom: 0}}>
                        <RebelLabel>Cost</RebelLabel>
                        <InputGroup>
                            <RebelInputGroupTextLeft>
                                {props.currency}
                            </RebelInputGroupTextLeft>
                            <RebelInputMiddle
                                placeholder=""
                                type="number"
                                value={props.miscCost[1].cost}
                                onChange={e => props.handleMiscellaneousChange(parseInt(e.target.value), props.miscCost[1].id, "cost")}
                            />
                            <RebelFormFeedback>Required</RebelFormFeedback>
                            <RebelInputGroupTextRight style={{padding: "0px"}}>
                                <RebelCheckboxButton onClick={x => props.handleMiscellaneousChange(props.miscCost[1].pp, props.miscCost[1].id, "pp")}>
                                    {props.miscCost[1].pp}
                                </RebelCheckboxButton>
                            </RebelInputGroupTextRight>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col lg="1" style={{display: "flex", alignItems: "center", paddingBottom: "8px"}}>
                    <RebelDeleteButtonContainer onClick={(x) => props.deleteMiscCost(props.miscCost[1].id)}>
                        <RebelEditIcon icon={['fas', 'trash']} style={{height: "25px"}}/>
                    </RebelDeleteButtonContainer>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default RebelMiscellaneousInputs;

const RebelLabel = styled.label`
    color: ${RebelColors.gold};
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 0.95rem;
    display: block;
`;

/* Standalone input with full border-radius (Cost Title) */
const RebelInputStandalone = styled(Input)`
    font-size: 16px;
    border: 1px solid ${RebelColors.border};
    border-radius: 6px;
    background-color: #3b3f45;
    color: ${RebelColors.text};
    padding: 10px 16px;
    min-height: 46px;
    transition: all 0.3s ease;

    &:focus {
        background-color: #424752;
        border-color: ${RebelColors.gold};
        box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.1);
        color: ${RebelColors.text};
        outline: none;
    }

    &::placeholder {
        color: ${RebelColors.primaryMuted};
    }

    &:hover {
        border-color: ${RebelColors.borderLight};
        background-color: #424752;
    }

    &:disabled {
        background-color: ${RebelColors.surface};
        color: ${RebelColors.primaryMuted};
        cursor: not-allowed;
    }
`;

/* Middle input with no border-radius (between currency and per person button) */
const RebelInputMiddle = styled(Input)`
    font-size: 16px;
    border: 1px solid ${RebelColors.border};
    border-radius: 0 !important;
    border-left: none;
    border-right: none;
    background-color: #3b3f45;
    color: ${RebelColors.text};
    padding: 10px 16px;
    min-height: 46px;
    transition: all 0.3s ease;

    &:focus {
        background-color: #424752;
        border-color: ${RebelColors.gold};
        box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.1);
        color: ${RebelColors.text};
        outline: none;
        border-left: none;
        border-right: none;
    }

    &::placeholder {
        color: ${RebelColors.primaryMuted};
    }

    &:hover {
        border-color: ${RebelColors.borderLight};
        background-color: #424752;
    }

    &:disabled {
        background-color: ${RebelColors.surface};
        color: ${RebelColors.primaryMuted};
        cursor: not-allowed;
    }
`;

/* Left input group text (currency symbol) - rounded left corners only */
const RebelInputGroupTextLeft = styled.span`
    background-color: #2a2e34;
    border: 1px solid ${RebelColors.border};
    border-right: none;
    color: ${RebelColors.text};
    border-radius: 6px 0 0 6px;
    padding: 10px 16px;
    min-height: 46px;
    display: flex;
    align-items: center;
`;

/* Right input group text (per person button wrapper) - rounded right corners only */
const RebelInputGroupTextRight = styled.span`
    background-color: #2a2e34;
    border: 1px solid ${RebelColors.border};
    border-left: none;
    color: ${RebelColors.text};
    border-radius: 0 6px 6px 0;
    padding: 10px 16px;
    min-height: 46px;
    display: flex;
    align-items: center;
`;

const RebelFormFeedback = styled(SmallFormFeedback)`
    color: ${RebelColors.danger};
`;

const RebelCheckboxButton = styled(Button)`
    height: 100%;
    margin: 0px;
    border: none;
    border-radius: 0 6px 6px 0;
    background-color: ${RebelColors.gold};
    color: #000000;
    min-height: 46px;
    padding: 10px 16px;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
        background-color: #e6c200;
        color: #000000;
    }

    &:focus {
        background-color: ${RebelColors.gold};
        color: #000000;
        box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.2);
    }

    &:active {
        background-color: #cca300;
        color: #000000;
    }
`;

const RebelDeleteButtonContainer = styled(PinkButtonContainer)`
    background-color: transparent;
    border: 1px solid ${RebelColors.border};
    transition: all 0.3s ease;

    &:hover {
        background-color: ${RebelColors.danger};
        border-color: ${RebelColors.danger};
    }
`;

const RebelEditIcon = styled(EditIcon)`
    color: ${RebelColors.primary};

    ${RebelDeleteButtonContainer}:hover & {
        color: #ffffff;
    }
`;
